export class SessionFilter {
  constructor(module) {
    this.module = module;
  }

  toggleFilter(target, filterName) {
    if (target.classList.contains("btn")) {
      const { value } = target.dataset;

      const newFilters = Object.assign({}, this.module.activeFilters);

      if (filterName === "dates") {
        newFilters[filterName] = [value];
      } else {
        const filterValues = newFilters[filterName] || [];
        newFilters[filterName] = filterValues.includes(value)
          ? filterValues.filter((item) => item !== value)
          : filterValues.concat(value);
      }

      this.module.set("activeFilters", newFilters);
      this.module.details.close();
    }
  }

  updateSessionVisibility() {
    const matchedSessions = Array.from(this.module.sessions).filter((session) =>
      this.module.filter.isSessionMatched(session)
    );

    const notMatchedSessions = Array.from(this.module.sessions).filter(
      (session) => !matchedSessions.includes(session)
    );

    matchedSessions.forEach((session) =>
      session.classList.add("session--visible")
    );
    notMatchedSessions.forEach((session) =>
      session.classList.remove("session--visible")
    );
  }

  updateFilterButtons() {
    const allValues = Object.values(this.module.activeFilters).flat();
    this.module.filterButtons.forEach((button) => {
      button.classList.toggle("session__filter-button--active", allValues.includes(button.dataset.value));
      button.classList.toggle("btn-primary", allValues.includes(button.dataset.value));
    });
  }

  isSessionMatched(session) {
    return Object.entries(this.module.activeFilters).reduce(
      (matchStatus, [filterName, filterValues]) => {
        const dataFromSession = session.dataset[filterName];
        if (!dataFromSession) return matchStatus;

        const dataFromSessionJSON = JSON.parse(dataFromSession);
        const isMatch =
          filterValues.length === 0 ||
          filterValues.some((value) =>
            dataFromSessionJSON.map(String).includes(String(value))
          );
        return matchStatus && isMatch;
      },
      true
    );
  }

  setInitialDate() {
    const firstDateObject = this.module.filters.querySelector(".sessions__filter-row[data-for='dates'] .btn")
    if (firstDateObject) {
      const newActiveFilters = Object.assign({}, this.activeFilters);
      newActiveFilters.dates = [firstDateObject.dataset.value];
      this.module.set("activeFilters", newActiveFilters);
    }
  }

  toggleTimeslots() {
    const timeslotVisibility = Array.from(this.module.timeslots).map((timeslot) => {
      const hasVisibleSession = timeslot.querySelector(".session--visible");
      timeslot.style.display = hasVisibleSession ? "" : "none";
      return hasVisibleSession;
    });
  
    const isNotFound = !timeslotVisibility.some((visible) => visible);
    this.module.notFound.classList.toggle("sessions__not-found--visible", isNotFound);
  }
}
